<template>
  <div class="wai">
    <div class="zhu">
      <el-table :data="bdc_list" style="width: 100%">
        <el-table-column prop="id" label="id" width="80" />
        <el-table-column prop="username" label="账号" width="250" />
        <el-table-column prop="name" label="姓名" width="100" />
        <el-table-column prop="cardid" label="身份证" width="180" />
        <el-table-column prop="orderNo" label="订单号" />
        <el-table-column prop="create_time" label="创建时间" />
        <el-table-column label="操作" width="100">
          <template #default="{ row }">
            <el-button type="primary" @click="shenpi(row)" size="small">审批</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @current-change="getlist()" :pager-count="5" v-model:page-size="page.pageSize" v-model:current-page="page.pageno" background
        layout="prev, pager, next" :total="page.total" />
    </div>




    <el-dialog @close="dialogclose()" v-model="dialog" width="750" :close-on-click-modal="false">
      <div class="xq">
        <div class="xinxi">
          <div class="group">
            <div class="lab">
              姓名
            </div>
            <div class="value">
              {{bdcxq.name}}
            </div>
          </div>
          <div class="group">
            <div class="lab">
              身份证
            </div>
            <div class="value">
              {{ formatIdCard(bdcxq.cardid) }}
            </div>
          </div>
          <div class="group">
            <div class="lab">
              时间
            </div>
            <div class="value">
              {{bdcxq.create_time}}
            </div>
          </div>
        </div>
        <VueOfficePdf :src="bdcxq.authurl" @error="handleError" />
        <div class="pifu">
          <div class="">
            <el-button type="danger" @click="youzui()">有罪</el-button>
            <el-button type="success" @click="wuzui()">无罪</el-button>
          </div>
          <div class="">
            <el-input v-if="miaoshu" v-model="youzuimiaoshu" style="width: 240px" placeholder="请输入罪状" clearable />
            <el-button v-if="miaoshu" type="primary" @click="shenpitijiao('0')">有罪二次确认</el-button>
            <el-button v-if="erci" type="primary" @click="shenpitijiao('2')">无罪二次确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script setup>
  import {
    onMounted,
    reactive,
    ref
  } from 'vue';
  import VueOfficePdf from '@vue-office/pdf'
  import {
    bdc_review,
    shenhe_bdc,
    shenpiorder
  } from '@/api/api';
  import {
    ElMessage
  } from 'element-plus';
  import {
    useLoadingStore
  } from '../../store/loadingstore'
  const loadingStore = useLoadingStore();
  // 弹窗
  const dialog = ref(false)
  // 二次确认按钮
  const erci = ref(false)
  const youzuimiaoshu = ref('')
  const miaoshu = ref(false)

  const youzui = () => {
    miaoshu.value = true
    erci.value = false
  }
  const wuzui = () => {
    erci.value = true
    miaoshu.value = false
  }
  const shenpitijiao = async (status) => {
    if (status == 0 && youzuimiaoshu.value == '') {
      ElMessage.error('请输入驳回原因')
      return
    }
    loadingStore.show('正在提交数据...');
    const data = {
      orderNo: bdcxq.value.orderNo,
      status: status,
      des: youzuimiaoshu.value
    }
    const res = await shenhe_bdc(data)
    if (res.code == 200) {
      dialog.value = false
      loadingStore.hide();
      getlist()
    }
  }

  // 分页参数
  const page = reactive({
    pageno: 1,
    pageSize: 13,
    total: 0,
  })

  onMounted(() => {
    getlist()
  })

  // 不动产列表
  const bdc_list = ref()
  // 不动产单个详情
  const bdcxq = ref()

  const shenpi = (row) => {
    bdcxq.value = row
    dialog.value = true
  }
  const dialogclose = () => {
    bdcxq.value = ''
    erci.value = false
    youzuimiaoshu.value = ''
    miaoshu.value = false
  }

  const getlist = async () => {
    const data = {
      page: page.pageno,
      pageSize: page.pageSize
    }
    const res = await bdc_review(data)
    if (res.code == 200) {
      page.total = res.data.total
      page.pageSize = res.data.pageSize
      page.pageno = res.data.pageno
      bdc_list.value = res.data.list
    }
  }
  // 分割身份证
  const formatIdCard = (cardId) => {
    if (!cardId || cardId.length !== 18) {
      return cardId || '';
    }
    const parts = [
      cardId.substring(0, 3),
      cardId.substring(3, 6),
      cardId.substring(6, 10),
      cardId.substring(10, 14),
      cardId.substring(14)
    ];
    return parts.join(' ');
  };
</script>

<style lang="scss" scoped>
  .wai {
    width: 100%;
    height: 100%;
    padding: 0 5px;

    .zhu {
      width: 100%;
      height: calc(100% - 45px);
      overflow-y: auto;
      border-radius: 10px;
    }

    .page {
      height: 45px;
      width: 100%;
      display: flex;
      padding: 0 30px;
      justify-content: right;
    }
  }

  .xq {
    .xinxi {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;

      .group {
        display: flex;
        // width: 250px;
        font-size: 18px;
        margin: 0 10px;

        .lab {
          margin-right: 20px;
        }

        .value {
          color: #000;
        }
      }
    }

    .pifu {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
  }
</style>
